import { isProductionLikeAppEnv } from '@/configs/env'

// Longer timeout in non-production environment for the BE server responds slowly sometimes
export const timeout = !isProductionLikeAppEnv ? 10 * 1000 : 5 * 1000

export const getNextjsFetchCacheOptions = (revalidate: number): Pick<RequestInit, 'next'> => ({
  next: {
    revalidate,
  },
})

// fetch cache (SWR) for 1 minute in server side
// NOTE: Untick "Network - Disable cache" in browser devtools to see the effect
// Ref: https://nextjs.org/docs/app/api-reference/functions/fetch#hard-refresh-and-caching-in-development
export const defaultNextjsFetchCacheOptions = getNextjsFetchCacheOptions(60)
